import React from 'react';
import PropTypes from 'prop-types';
import {Grid, Tooltip} from "@mui/material";
import Badge from "../../../../../../../components/Badge";
import {WmsItemsStatus} from "../../../../../../../utils/WmsItemsStatus";
import {FormattedMessage} from "react-intl";
import {greyishBlue700, red600} from "../../../../../../../assets/jss/main";
import moment from "moment/moment";
import {Link} from "react-router-dom";

DisplayHive.propTypes = {
    hive: PropTypes.object.isRequired
};

function DisplayHive({hive}) {

    const getContainerTooltip = (container) => {

        if (0 === container.wmsItems.length) {
            return (
                <>
                    N/A
                </>
            )
        }

        const shipmentItemCount = container.wmsItems[0].lineItem.currentShipment?.wmsItemsCount
        const containerItemCount = container.wmsItems.length

        return (
            <ul style={{margin: 0, padding: "8px"}}>
                <li><FormattedMessage id={"wms.admin.hiveList.order.externalId"} values={{externalId: container.wmsItems[0].lineItem.order.externalId ?? "N/A"}}/></li>
                <li><FormattedMessage id={"wms.admin.hiveList.order.age"} values={{age: moment().diff(container.wmsItems[0].lineItem.order.createdAt, 'day')}}/></li>
                <li><FormattedMessage id={"wms.admin.hiveList.itemCount"} values={{count: `${containerItemCount}`, total: `${shipmentItemCount}`}}/></li>
            </ul>
        )
    }

    return (
        <Grid
            container
            direction={"column"}
            gap={"8px"}
            sx={{
                color: greyishBlue700,
                overflow: "auto"
            }}
        >
            <FormattedMessage id={"wms.admin.hiveList.hiveName"} values={{hiveName: hive.hiveName}} />

            <Grid container gap={'8px'} sx={{marginBottom: "16px", ...(hive.rowSize !== null ? {display: 'grid', gridTemplateColumns: `repeat(${hive.rowSize}, max-content)`} : {display: 'flex', flexWrap: 'wrap'})}}>
                {hive.containers.map((container) => {
                    let color = "outline"
                    let isLate = false
                    let lateIndicator = false
                    let isEmpty = true

                    if (0 !== container.wmsItems.length) {
                        isEmpty = false
                    }

                    if (container.wmsItems.some((item) => 3 < moment().diff(item.lineItem.order.createdAt, 'day'))) {
                        isLate = true
                    }

                    if (!isLate && container.wmsItems.some((item) => WmsItemsStatus.SORTED === item.status)) {
                        color = "warningContained"
                    } else if (container.wmsItems.some((item) => WmsItemsStatus.SORTED === item.status)) {
                        color = "errorContained"
                    }

                    if (0 < container.wmsItems.length && container.wmsItems.every((item) => WmsItemsStatus.READY_TO_BE_PACKED === item.status)) {
                        color = "success"

                        if (isLate) {
                            lateIndicator = true
                        }
                    }

                    return (
                        <Tooltip title={getContainerTooltip(container)} arrow placement="top" key={container.id}>
                            <Link rel={isEmpty ? undefined : "noopener noreferrer"} style={{textDecoration: "none"}} target={isEmpty ? null : "_blank"} to={isEmpty ? "#" : "/picking/orders/show/"+container.wmsItems[0].lineItem.order.id}>
                                <Badge indicator={lateIndicator} indicatorColor={red600} size={"xl"} color={color}>{container.name}</Badge>
                            </Link>
                        </Tooltip>
                    )
                })}
            </Grid>
        </Grid>
    );
}

export default DisplayHive;
